import { render, staticRenderFns } from "./attr_tooltips.vue?vue&type=template&id=7a465933&"
import script from "./attr_tooltips.vue?vue&type=script&lang=js&"
export * from "./attr_tooltips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3665044678/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a465933')) {
      api.createRecord('7a465933', component.options)
    } else {
      api.reload('7a465933', component.options)
    }
    module.hot.accept("./attr_tooltips.vue?vue&type=template&id=7a465933&", function () {
      api.rerender('7a465933', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parties/attr_tooltips.vue"
export default component.exports